export enum enumProductServiceType {
  ISF,
  ENTRY_SUMMARY,
  INTERNATIONAL_SHIPPING,
  MARINE_INSURANCE,
  CUSTOMS_BONDS,
  PLAN,
  ASSIGNED_CBP_NUMBER_REQUEST,
}
